module.exports = __webpack_public_path__ + "img/page2img3.8836cb5a.png";